const stage = process.env.REACT_APP_STAGE;

export const amplifyConfig = {
  Auth: {
    identityPoolId:
      stage === "1-0-0"
        ? "ap-northeast-1:bff94cf2-ccfb-40ac-a643-5b02b90f249a"
        : "ap-northeast-1:83de8586-4f19-41ed-b217-71a494c6bab1",
    region: "ap-northeast-1",
    userPoolId:
      stage === "1-0-0"
        ? "ap-northeast-1_JBN6JpbuE"
        : "ap-northeast-1_pRqTxLl73",
    userPoolWebClientId:
      stage === "1-0-0"
        ? "6ab3iq4vp18etcj4r5ebh99prq"
        : "6i7ls201i6bkgqnut2eegiue71",
  },
  API: {
    aws_appsync_graphqlEndpoint:
      stage === "1-0-0"
        ? "https://i6cutb5afbes3le4nr6pcws4le.appsync-api.ap-northeast-1.amazonaws.com/graphql"
        : "https://76dx6cycqbbifmxojojxkmxwim.appsync-api.ap-northeast-1.amazonaws.com/graphql",
    aws_appsync_region: "ap-northeast-1",
    aws_appsync_authenticationType: "AMAZON_COGNITO_USER_POOLS",
    aws_appsync_apiKey:
      stage === "1-0-0"
        ? "da2-t4ui4ws7mrdltaqp4rmnqcrsri"
        : "da2-s5cwbjmwrfbvxdvw2y5zsqfvce",
  },
  Storage: {
    AWSS3: {
      bucket: `schema-${stage}-uploads`,
      region: "ap-northeast-1",
    },
  },
};

export const otherConfig = {
  MQTT: {
    region: "ap-northeast-1",
    endpoint: "wss://a2gjcka2l9qoa5-ats.iot.ap-northeast-1.amazonaws.com/mqtt",
  },
};

export const firebaseConfig = {
  apiKey: "AIzaSyBrppMMyCZlXxc5rftYwqyvzTPmxQkqF_I",
  authDomain: "choku-7931f.firebaseapp.com",
  projectId: "choku-7931f",
  storageBucket: "choku-7931f.appspot.com",
  messagingSenderId: "529064121225",
  appId: "1:529064121225:web:1ec42088f743f502b30758",
  measurementId: "G-T2MJ2GVRC5",
};

export const VapidKey =
  "BIngTb_b_SAqFVIDmmFGRUxbOUf6FEGZTH62WVFJ1qeNEdG0FdWU5ctZO18AFjCkUO5hM2efYaK-WocKo0QIvu4";

export const StripePublishableKey =
  stage === "1-0-0"
    ? "pk_live_U2p9okT235IHqQKVKrjtRVQX007KU383HU"
    : "pk_test_5UID8FAOyrgL5uRPVOeiIoqC00Tx65khKv";

export const paymentEndpoint =
  stage === "1-0-0"
    ? "https://l98m2mia7g.execute-api.ap-northeast-1.amazonaws.com"
    : "https://p27qjmpli1.execute-api.ap-northeast-1.amazonaws.com";
